import React, { useRef, useEffect } from 'react'
import injectStyles from 'react-jss'
import moment from 'moment'
import CloseIcon from 'Assets/Images/icons/modalClose'
import { styles } from './styles'
import GenericFlatButton from '../../GenericFlatButton'

const NmbrsModalBody = ({ nmbrsData, ambassador, onClose, classes }) => {
  const {
    firstName,
    lastName,
    email,
    mobilePhone,
    nationalRegistrationNumber,
    paymentDetails: {
      bankAddress1,
      bankAddress2,
      bankCity,
      bankPostCode,
      accountNumber,
    },
  } = ambassador
  const {
    initials,
    nationality,
    birthplace,
    gender,
    birthdate,
    taxRebate,
    updatedAt,
  } = nmbrsData

  const ModalItem = ({ label, value }) => {
    return (
      <div className={classes.modalItemWrapper}>
        <div className={classes.itemTitle}>{label}</div>
        <div className={classes.itemValue}>{value}</div>
      </div>
    )
  }

  const modalRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = event => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose()
      }
    }

    const handleEscapeKeyPress = event => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscapeKeyPress)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscapeKeyPress)
    }
  }, [onClose])

  const houseNumber = bankAddress2 && bankAddress2.split(' ')[0]
  const suffix = bankAddress2 && bankAddress2.slice(houseNumber.length).trim()

  return (
    <div className={classes.modalContainer} ref={modalRef}>
      <span className={classes.close} onClick={onClose}>
        <CloseIcon />
      </span>
      <div className={classes.nmbrsModalTitle}>First day at work form</div>
      <div className={classes.nmbrsDescription}>
        This form will be sent to NMBRS once BA account is created
      </div>
      <div className={classes.modalDataWrapper}>
        <div className={classes.modalRow}>
          <ModalItem label={'Name'} value={firstName} />
          <ModalItem label={'Initials'} value={initials} />
          <ModalItem label={'Surname'} value={lastName} />
        </div>
        <div className={classes.modalRow}>
          <ModalItem label={'BSN'} value={nationalRegistrationNumber} />
          <ModalItem label={'Nationality'} value={nationality} />
        </div>
        <div className={classes.modalRow}>
          <ModalItem label={'Gender'} value={gender} />
          <ModalItem
            label={'Birthdate'}
            value={moment.utc(Number(birthdate)).format('DD MMM YYYY')}
          />
          <ModalItem label={'City of birth'} value={birthplace} />
        </div>
        <div className={classes.modalRow}>
          <ModalItem label={'Phone number'} value={mobilePhone} />
          <ModalItem label={'Email'} value={email} />
        </div>
        <div className={classes.divider} />
        <div className={classes.modalRow}>
          <ModalItem label={'Street'} value={bankAddress1} />
          <ModalItem label={'House number'} value={houseNumber || '-'} />
          <ModalItem label={'House suffix'} value={suffix || '-'} />
        </div>
        <div className={classes.modalRow}>
          <ModalItem label={'City'} value={bankCity} />
          <ModalItem label={'ZIP code'} value={bankPostCode} />
        </div>
        <div className={classes.divider} />
        <div className={classes.modalRow}>
          <ModalItem label={'IBAN'} value={accountNumber} />
        </div>
        <div className={classes.divider} />
        <div className={classes.modalRow}>
          <ModalItem label={'Tax rebate'} value={taxRebate ? 'YES' : 'NO'} />
          <ModalItem
            label={'Signed on'}
            value={moment(Number(updatedAt)).format('YYYY-MM-DD HH:mm:ss')}
          />
        </div>
      </div>
      <div className={classes.cancelButton}>
        <GenericFlatButton type={'outline'} title={'Close'} onClick={onClose} />
      </div>
    </div>
  )
}

export default injectStyles(styles)(NmbrsModalBody)
